var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "detail" } }, [
            _vm._v(_vm._s(_vm.$t("detailLabel")))
          ]),
          _c("el-menu-item", { attrs: { index: "accountsummary" } }, [
            _vm._v(_vm._s(_vm.$t("summaryLabel")))
          ])
        ],
        1
      ),
      _c("detail", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "detail",
            expression: "activeIndex == 'detail'"
          }
        ],
        ref: "detail"
      }),
      _c("accountsummary", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "accountsummary",
            expression: "activeIndex == 'accountsummary'"
          }
        ],
        ref: "accountsummary"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }